import React, { Component, PropsWithChildren } from 'react';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

interface MapComponentProps {
  google: any;
  location?: { lat: number; lng: number };
  onLocationSelect: (lat: number, long: number) => void;
  onSearch: (locationObject: any) => void;
  isEdit?: boolean;
}

interface MapComponentState {
  position: { lat: number; lng: number } | undefined;
}

class MapComponent extends Component<PropsWithChildren<MapComponentProps>, MapComponentState> {

  readonly state = {
    position: undefined
  };

  componentDidMount() {
    if (this.props.location) {
      this.setState({ position: this.props.location });
    }
  }

  componentDidUpdate(prevProps: MapComponentProps, prevState: MapComponentState) {
    if (this.props.location && prevState.position !== this.props.location) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ position: this.props.location });
    }
  }

  onClick = (t: any, map: any, cord: any) => {
    if (this.props.isEdit) {
      const { latLng } = cord;
      const lat = latLng.lat();
      const lng = latLng.lng();

      this.setState({ position: { lat, lng } });
      this.props.onLocationSelect(lat, lng);
    }
  };

  render() {
    return (
        <>
          <Map
            google={this.props.google}
            onClick={(t: any, map: any, cord: any) => this.onClick(t, map, cord)}
            containerStyle={{
              width: '98%',
              height: '800px'
            }}
            initialCenter={
              {
                lat: this.props.location ? this.props.location.lat : 51.5074,
                lng: this.props.location ? this.props.location.lng : 0.1278,
              }
            }
            zoom={3}
          />
          {this.props.isEdit && (
            <div className="col-5 pl-5 mt-2 ml-5">
              <GooglePlacesAutocomplete
                selectProps={{ onChange: (object: any) => this.props.onSearch(object) }}
              />
            </div>
          )}
          {this.state.position && (
            <Marker
              position={this.state.position ? this.state.position : undefined}
            />
          )}
        </>
    );
  }
}

const GoogleMap = GoogleApiWrapper({
  apiKey: String(window.config.googleApiKey)
})(MapComponent);

export default GoogleMap;
